import { render, staticRenderFns } from "./retire.vue?vue&type=template&id=32d315a8&scoped=true&"
import script from "./retire.vue?vue&type=script&lang=js&"
export * from "./retire.vue?vue&type=script&lang=js&"
import style0 from "./retire.vue?vue&type=style&index=0&id=32d315a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d315a8",
  null
  
)

export default component.exports